import React, { Component } from 'react'
import { withRouter } from 'react-router'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import LinkSocialUserPageUI from './LinkSocialUserPageUI.js'

class LinkSocialUserPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
    }
  }

  render() {
    let params = new URLSearchParams(window.location.search)
    let provider = params.get('provider')
    if (!['Facebook', 'Google'].includes(provider))
      provider = 'Unknown'

    return (
      <LinkSocialUserPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        provider={provider}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  getMessages(context) {
    let arr = [
      'c_link_social_acct',
      'c_soc_link_account',
      'c_password',
      'c_submit',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_link_usr', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default withRouter(LinkSocialUserPageSF)
